// extracted by mini-css-extract-plugin
module.exports = {"setting-modal":"SchedulingEdit_setting-modal__2p10d"};